module.exports = __webpack_public_path__ + "static/images/congratulations.52f739a.png";